module.exports = Configurations;